import { assignShipToAddressModalStyles } from "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

assignShipToAddressModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        background: ${getColor("common.background")};
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
           
        } */
        }
    `,
};
assignShipToAddressModalStyles.saveButton = {
    css: css`
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
assignShipToAddressModalStyles.modal = {
    cssOverrides: {
        modalTitle: css`
            color: ${getColor("text.main")};
        `,
    },
};
assignShipToAddressModalStyles.shipToNumberLabel = {
    css: css`
        color: ${getColor("text.main")};
    `,
};
assignShipToAddressModalStyles.addressInfoDisplay = {
    address1Text: {
        css: css`
            color: ${getColor("text.main")} !important;
        `,
    },
    cityText: {
        css: css`
            color: ${getColor("text.main")} !important;
        `,
    },
    stateText: {
        css: css`
            color: ${getColor("text.main")} !important;
        `,
    },
};
